import {
  TEXT,
  LAYOUT_COLUMNS,
  LAYOUT_LIST,
  LayoutListDefinition
} from '../items';
import { Translator } from '../Translator';
import { translate } from './translate';

export const Text4: Translator = sequence => {
  const LayoutListItems: LayoutListDefinition[] = [];

  const root = translate(sequence, item => {
    if (item.__typename === 'Text') {
      LayoutListItems.push({
        id: `${item.id}_list`,
        type: LAYOUT_LIST,
        values: {
          align: 'left'
        },
        items: [
          {
            type: TEXT,
            id: `${item.id}_title`,
            items: [],
            values: {
              value: item.title as string,
              variant: 'heading1'
            }
          },
          {
            type: TEXT,
            id: `${item.id}_body`,
            items: [],
            values: {
              value: item.body,
              variant: 'text'
            }
          }
        ]
      });
    }

    return null;
  });

  root.items.push({
    type: LAYOUT_COLUMNS,
    id: '1',
    values: {},
    items: LayoutListItems
  });

  return root;
};
